import PropTypes from 'prop-types';
import { ComponentLoader } from 'cat-ecommerce-alloy';
import { useSelector } from 'react-redux';
import AddEquipmentCTA from '../../../../components/common/myEquipmentHeader/equipmentPanel/AddEquipmentCTA';
import SelectEquipmentCTA from '../../../../components/common/myEquipmentHeader/equipmentPanel/SelectEquipmentCTA';
import DisplayEquipment from '../../../../components/common/myEquipmentHeader/equipmentPanel/DisplayEquipment';
import { FLEX_ALIGNMENT } from '../constants';
import cpStyles from './MyEquipmentCTA.scss';
import useEquipmentDrawer from '@app/hooks/useEquipmentDrawer';

const MyEquipmentCTA = ({ widgetProps, widgetIdentifier }) => {
  const selectedEquipment = useSelector(
    s => s.myEquipment.equipments?.selectedEquipment
  );
  const storeId = useSelector(s => s.common?.storeId);
  const myEquipmentList = useSelector(
    s => s.myEquipment.equipments?.myEquipmentList
  );
  const initialLoading = useSelector(s => s.myEquipment?.initialLoading);
  const isLoading = useSelector(s => s.myEquipment?.isLoading);
  const { openEditDrawer, openAddDrawer, getDrawerComponent } =
    useEquipmentDrawer();
  const serialNumValidationStatus = useSelector(
    state => state.myEquipment?.serialNumValidationStatus
  );

  let equipmentWidget;

  /** case 1: blank status while loading equipment data or page loading */
  if (
    (isLoading && serialNumValidationStatus !== 'pending') ||
    initialLoading
  ) {
    equipmentWidget = <ComponentLoader />;
  } else if (!selectedEquipment?.model) {
    /**case 2: Add Equipment : when there is no selected equipment
     * 2.a:  no equipment in the list -- Add Equipment
     * 2.b:  otherwise -- selected equipment   */
    if (myEquipmentList.length === 0) {
      equipmentWidget = (
        <AddEquipmentCTA
          storeId={storeId}
          widgetIdentifier={widgetIdentifier}
        />
      );
    } else {
      equipmentWidget = (
        <SelectEquipmentCTA
          selectedEquipment={selectedEquipment}
          myEquipmentList={myEquipmentList}
          openAddDrawer={openAddDrawer}
        />
      );
    }
  } else {
    /** case 3: We have data ! display information */
    equipmentWidget = (
      <DisplayEquipment
        selectedEquipment={selectedEquipment}
        myEquipmentList={myEquipmentList}
        hideCheckbox={true}
        displaySSROCTA={true}
        widgetIdentifier={widgetIdentifier}
        openEditDrawer={openEditDrawer}
      />
    );
  }

  return (
    <>
      <div
        className={`d-flex p-3 ${cpStyles['myequip-widget-container']}`}
        style={{
          justifyContent:
            FLEX_ALIGNMENT[widgetProps.widgetAlignment] || 'center',
          width: widgetProps.width
        }}
      >
        <div className={`w-100 ${cpStyles['campaignPage--myequip--widget']}`}>
          {equipmentWidget}
        </div>
      </div>
      {getDrawerComponent({ currentEquipment: selectedEquipment })}
    </>
  );
};

MyEquipmentCTA.propTypes = {
  widgetProps: PropTypes.shape({
    width: PropTypes.string,
    widgetAlignment: PropTypes.string
  }),
  widgetIdentifier: PropTypes.string
};

export default MyEquipmentCTA;
